import React from 'react';

export default function AlertDialog({
  title = 'Confirm',
  bodytext = 'Are you sure?',
  okButtonText = 'Ok',
  successDialog,
  sucPrams,
}) {
  return (
    <div className="modalBackground">
      <div className="logout-contnr">
        <span className="logout-hdng">{title}</span>
        <span className="logout-text tab-bg">{bodytext}</span>
        <span className="logout-action">
          <button onClick={() => successDialog(sucPrams)} className="actn-yes">
            {okButtonText}
          </button>
        </span>
      </div>
    </div>
  );
}
